import { NgTemplateOutlet } from "@angular/common";
import { Component, inject, TemplateRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef } from "@angular/material/dialog";

export interface BaseDialogButton {
  label: string;
  action?: 'close' | 'submit';
  color?: 'primary' | 'accent' | 'warn' | undefined;
  disabled?: boolean;
  type?: 'button' | 'submit';
}

export interface BaseDialogData {
  title?: string;
  context?: any;
  template: TemplateRef<any>;
  showFooter?: boolean;
  buttons?: BaseDialogButton[];
}

@Component({
  selector: 'app-base-dialog',
  templateUrl: './base-dialog.component.html',
  imports: [
    MatDialogModule,
    NgTemplateOutlet,
  ]
})
export class BaseDialogComponent {
  dialogRef = inject(MatDialogRef<BaseDialogComponent>);
  data = inject(MAT_DIALOG_DATA) as BaseDialogData;


  close(result?: any) {
    this.dialogRef.close(result);
  }

  handleButtonClick(button: BaseDialogButton) {
    if (button.action === 'close') {
      this.close();
    } else if (button.action === 'submit') {
      this.close(this.data.context);
    }
  }
}